import React, { useEffect, useRef, useState } from "react";
import "../InvoicePage.scss";
import { default as GzTopIcon } from "../../../icons/gz-top.svg";
import { default as GzTopIconDisabled } from "../../../icons/gz-top-disabled.svg";
import { getLastRelevantStatus, getProgressIndexFromStatus } from "../utils/deliveryProgressUtils";

function InvoiceDeliveryComponent({ orders, selectedTracking, updateTrackingIndex }) {
    const [data, setData] = useState([]);
    const [points] = useState(new Array(13).fill(0));
    const [progressIndex, setProgressIndex] = useState(null);
    const trackingItemRefs = useRef([]);

    useEffect(() => {
        setData(orders);

        const statuses = orders[selectedTracking]?.statuses ?? [];
        const lastRelevantStatus = getLastRelevantStatus(statuses);
        setProgressIndex(getProgressIndexFromStatus(lastRelevantStatus?.status));
    }, [orders, selectedTracking]);

    useEffect(() => {
        trackingItemRefs.current[selectedTracking]?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
            inline: 'center'
        });
    }, [selectedTracking]);

    return (
        <div className="invoice-sheet tracking">
            <div className="delivery_tracking_container">
                {
                    data.map((item, index) => {
                        return (
                            <div
                                key={index}
                                ref={el => trackingItemRefs.current[index] = el}
                                className={ `${index === selectedTracking ? 'selected' : '' } ${item?.statuses[0]?.status === 'DELIVERED' ? 'delivered' : '' }` }
                                onClick={() => updateTrackingIndex(index)}
                            >
                                { item.tracking_number }
                            </div>
                        )
                    })
                }
            </div>

            <div className="delivery_progress_container">
                <div className="header">Arriving { data[selectedTracking]?.estimated_acceptance_date?.split(' ').slice(0, -1).join(' ') } in TBS</div>
                <div className="content">
                    <div>
                        <div className="from">
                            <div className="city_code">NYC</div>
                            <div>New-York</div>
                        </div>

                        <div className="tracking-path-container">
                            <div className="path-start">
                                <div></div>
                            </div>
                            <div className={ `tracking-path-bar` }>
                                {
                                    points.map((item, index) => (
                                            <div key={index}>
                                                {
                                                    index <= progressIndex && progressIndex !== 0
                                                        ? <div className={ `active ${ progressIndex === 11 && 'fail-delivery' }` }>
                                                            {
                                                                index === progressIndex && progressIndex === 11
                                                                    ? <img src={GzTopIconDisabled} className='pin' alt="disabled"/>
                                                                    : (index === progressIndex && progressIndex !== 12 && <img src={GzTopIcon} className='pin' alt="pin"/>)
                                                            }
                                                        </div>
                                                        : <div className='inactive'></div>
                                                }
                                            </div>
                                        )
                                    )
                                }
                            </div>
                            <div className={`path-end ${progressIndex === 12 ? 'delivered' : ''}`}>
                                {progressIndex === 12 && <img src={GzTopIcon} className="pin" alt="pin" />}
                            </div>
                        </div>


                        <div className="to">
                            <div className="city_code">TBS</div>
                            <div>Tbilisi</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default InvoiceDeliveryComponent;